import i18n from 'i18n/config';

const tt = (key, defaultValue) => i18n.t(key, { defaultValue });
const getT = (t) => (typeof t === 'function' ? t : i18n.t.bind(i18n));

export const getIndustryOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('settings.siteProfile.industry.powerGeneration', { defaultValue: 'Power Generation' }), value: 'Power Generation' },
    { text: tr('settings.siteProfile.industry.pharmaceuticals', { defaultValue: 'Pharmaceuticals' }), value: 'Pharmaceuticals' },
    { text: tr('settings.siteProfile.industry.oilAndGas', { defaultValue: 'Oil and Gas' }), value: 'Oil and Gas' },
    { text: tr('settings.siteProfile.industry.buildingsAndFacilities', { defaultValue: 'Buildings and Facilities' }), value: 'Buildings and Facilities' },
    { text: tr('settings.siteProfile.industry.foodAndBeverage', { defaultValue: 'Food and Beverage' }), value: 'Food and Beverage' },
    { text: tr('settings.siteProfile.industry.metals', { defaultValue: 'Metals' }), value: 'Metals' },
  ];
};

// Deprecated: prefer getIndustryOptions(t) so language changes are reflected.
export const industryOptions = getIndustryOptions();

export const getVibrationPeakOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('settings.siteProfile.vibrationPeak.truePeak', { defaultValue: 'True Peak' }), value: 'true_peak' },
    { text: tr('settings.siteProfile.vibrationPeak.derivedPeak', { defaultValue: 'Derived Peak' }), value: 'derived_peak' }
  ];
};

export const vibrationPeakOptions = getVibrationPeakOptions();

export const lineFrequencyOptions = [
  { text: '60Hz', value: 60 },
  { text: '50Hz', value: 50 }
];

export const getChartFeatureOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('settings.siteProfile.chartFeature.peak', { defaultValue: 'Peak' }), value: 'peak' },
    { text: tr('settings.siteProfile.chartFeature.rms', { defaultValue: 'RMS' }), value: 'rms' }
  ];
};

export const chartFeatureOptions = getChartFeatureOptions();

export const getHealthScoreMethodPreferenceOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('settings.siteProfile.healthScoreMethod.anomalyDetection', { defaultValue: 'Anomaly Detection' }), value: 'anomaly_detection' },
    { text: tr('settings.siteProfile.healthScoreMethod.expertSystemModel', { defaultValue: 'Expert System Model' }), value: 'expert_system_model' }
  ];
};

export const healthScoreMethodPreferenceOptions = getHealthScoreMethodPreferenceOptions();

export const assetConditionOptions = [
  { text: '3 Levels', value: 3 },
  { text: '5 Levels', value: 5 }
];

export const subscriptionTypeOptions = [
  { text: 'Starter-125', value: 'STR-125', maxChannels: 125 },
  { text: 'Starter', value: 'STR', maxChannels: 200 },
  { text: 'Starter-250', value: 'STR-250', maxChannels: 250 },
  { text: 'Starter-500', value: 'STR-500', maxChannels: 500 },
  { text: 'Starter-750', value: 'STR-750', maxChannels: 750 },
  { text: 'Professional', value: 'PRO', maxChannels: 1000 },
  { text: 'Professional-1.5K', value: 'PRO-1.5K', maxChannels: 1500 },
  { text: 'Professional-2K', value: 'PRO-2K', maxChannels: 2000 },
  { text: 'Enterprise-2.5K', value: 'ENT-2.5K', maxChannels: 2500 },
  { text: 'Enterprise-3K', value: 'ENT-3K', maxChannels: 3000 },
  { text: 'Enterprise-3.5K', value: 'ENT-3.5K', maxChannels: 3500 },
  { text: 'Enterprise-4K', value: 'ENT-4K', maxChannels: 4000 },
  { text: 'Enterprise-5K', value: 'ENT-5K', maxChannels: 5000 },
  { text: 'Enterprise-6.25K', value: 'ENT-6.25K', maxChannels: 6250 },
  { text: 'Enterprise-7.5K', value: 'ENT-7.5K', maxChannels: 7500 },
  { text: 'Enterprise-8.75K', value: 'ENT-8.75K', maxChannels: 8750 },
  { text: 'Enterprise-10K', value: 'ENT-10K', maxChannels: 10000 },
  { text: 'Enterprise-12.5K', value: 'ENT-12.5K', maxChannels: 12500 },
  { text: 'Enterprise-20K', value: 'ENT-20K', maxChannels: 20000 },
];

// The translation key of each tier's label, shared by Site Profile and
// Organisation Settings.
const subscriptionTypeLabelKeys = {
  'STR-125': 'settings.siteProfile.dropdown.subscriptionType.starter125',
  STR: 'settings.siteProfile.dropdown.subscriptionType.starter',
  'STR-250': 'settings.siteProfile.dropdown.subscriptionType.starter250',
  'STR-500': 'settings.siteProfile.dropdown.subscriptionType.starter500',
  'STR-750': 'settings.siteProfile.dropdown.subscriptionType.starter750',
  PRO: 'settings.siteProfile.dropdown.subscriptionType.professional',
  'PRO-1.5K': 'settings.siteProfile.dropdown.subscriptionType.professional15k',
  'PRO-2K': 'settings.siteProfile.dropdown.subscriptionType.professional2k',
  'ENT-2.5K': 'settings.siteProfile.dropdown.subscriptionType.enterprise25k',
  'ENT-3K': 'settings.siteProfile.dropdown.subscriptionType.enterprise3k',
  'ENT-3.5K': 'settings.siteProfile.dropdown.subscriptionType.enterprise35k',
  'ENT-4K': 'settings.siteProfile.dropdown.subscriptionType.enterprise4k',
  'ENT-5K': 'settings.siteProfile.dropdown.subscriptionType.enterprise5k',
  'ENT-6.25K': 'settings.siteProfile.dropdown.subscriptionType.enterprise625k',
  'ENT-7.5K': 'settings.siteProfile.dropdown.subscriptionType.enterprise75k',
  'ENT-8.75K': 'settings.siteProfile.dropdown.subscriptionType.enterprise875k',
  'ENT-10K': 'settings.siteProfile.dropdown.subscriptionType.enterprise10k',
  'ENT-12.5K': 'settings.siteProfile.dropdown.subscriptionType.enterprise125k',
  'ENT-20K': 'settings.siteProfile.dropdown.subscriptionType.enterprise20k'
};

export const getSubscriptionTypeOptions = (t) => {
  const tr = getT(t);
  return subscriptionTypeOptions.map((option) => {
    const key = subscriptionTypeLabelKeys[option.value];
    return { ...option, text: key ? tr(key, { defaultValue: option.text }) : option.text };
  });
};

export const getVibrationDirectionOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('settings.siteProfile.vibrationDirection.tar', { defaultValue: 'Tangential, Axial, Radial' }), value: 1 },
    { text: tr('settings.siteProfile.vibrationDirection.hav', { defaultValue: 'Horizontal, Axial, Vertical' }), value: 2 }
  ];
};

export const vibrationDirectionOptions = getVibrationDirectionOptions();

export const getLanguageOptions = () => ([
  { text: 'English', value: 'en' },
  { text: 'Deutsch', value: 'de' },
  { text: 'Español', value: 'es' },
  { text: 'Français', value: 'fr' },
  { text: '日本語', value: 'ja' }
]);

export const languageOptions = getLanguageOptions();

export const currencyOptions = [
  { text: 'USD ($)', value: 'USD', symbol: '$', name: 'US Dollar' },
  { text: 'CAD ($)', value: 'CAD', symbol: '$', name: 'Canadian Dollar' },
  { text: 'EUR (€)', value: 'EUR', symbol: '€', name: 'Euro' },
  { text: 'INR (₹)', value: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { text: 'SGD ($)', value: 'SGD', symbol: '$', name: 'Singapore Dollar' },
  { text: 'AUD ($)', value: 'AUD', symbol: '$', name: 'Australian Dollar' },
  { text: 'JPY (¥)', value: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { text: 'GBP (£)', value: 'GBP', symbol: '£', name: 'British Pound' },
  { text: 'IDR (Rp)', value: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah' },
  { text: 'AED (د.إ)', value: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { text: 'BRL (R$)', value: 'BRL', symbol: 'R$', name: 'Brazilian Real' }
];


export const MESSAGE = {
  accountCodeError: (keywords, t) => getT(t)('settings.siteProfile.messages.accountCodeReservedKeyword', {
    keywords: keywords.join(', '),
    defaultValue: 'Account Code cannot start with a Petasense keyword - {{keywords}}'
  })
};

// Days a TX/VSX sensor must read zero before it becomes an instrumentation
// alert; the cloud rejects values outside these bounds.
export const TX_ZERO_VALUE_WINDOW = {
  settingKey: 'tx_zero_value_alert_window_days',
  defaultDays: 90,
  minDays: 7,
  maxDays: 180
};

// Returns the whole number of days, or null when the input is not one in range.
export const parseTxZeroValueWindow = (value) => {
  const text = String(value === null || value === undefined ? '' : value).trim();
  if (!/^\d+$/.test(text)) return null;
  const days = Number(text);
  if (days < TX_ZERO_VALUE_WINDOW.minDays || days > TX_ZERO_VALUE_WINDOW.maxDays) return null;
  return days;
};
